import { Component, computed, input } from '@angular/core';
import { AvatarSize } from '../avatar.types';

@Component({
  selector: 'ntt-avatar-company-icon',
  template: `<img [src]="src()" [alt]="alt()" />`,
  host: {
    '[class]': 'classes()',
  },
  styles: `
    :host {
      position: absolute;
      display: block;
      box-sizing: content-box;
      overflow: clip;
      border-radius: var(--radius-full, 50rem);
      border: 1.5px solid var(--bg-primary, white);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: var(--radius-full, 50rem);
    }

    :host(.ntt-avatar-company-icon--xs) {
      width: 10px;
      height: 10px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-company-icon--sm) {
      width: 12px;
      height: 12px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-company-icon--md) {
      width: 14px;
      height: 14px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-company-icon--lg) {
      width: 16px;
      height: 16px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-company-icon--xl) {
      width: 18px;
      height: 18px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-company-icon--2xl) {
      width: 20px;
      height: 20px;
      bottom: 0;
      right: 0;
      border-width: 1.667px;
    }
  `,
})
export class NttAvatarCompanyIcon {
  readonly size = input<AvatarSize>('md');
  readonly src = input.required<string>();
  readonly alt = input<string>('Company');

  protected readonly classes = computed(
    () => `ntt-avatar-company-icon ntt-avatar-company-icon--${this.size()}`,
  );
}
